import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-460623bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "canvas-tool" }
const _hoisted_2 = { class: "add-element-handler" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fad",
  "data-icon": "font-case",
  class: "svg-inline--fa fa-font-case",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 512"
}, [
  /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-secondary",
      fill: "#c9c1ec",
      d: "M608 160c-13.14 0-24.37 7.943-29.3 19.27C559.2 167.3 536.5 160 512 160c-70.58 0-128 57.41-128 128l.0007 63.93c0 70.59 57.42 128.1 127.1 128.1c24.51 0 47.21-7.266 66.7-19.26C583.6 472.1 594.9 480 608 480c17.67 0 32-14.31 32-32V192C640 174.3 625.7 160 608 160zM576 352c0 35.28-28.7 64-64 64s-64-28.72-64-64v-64c0-35.28 28.7-63.1 64-63.1s64 28.72 64 63.1V352z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-primary",
      fill: "currentColor",
      d: "M349.1 436.8l-144-384C201.3 40.3 189.3 32.01 176 32.01S150.7 40.3 146 52.76l-144 384c-6.203 16.56 2.188 35 18.73 41.22c16.55 6.125 34.98-2.156 41.2-18.72l28.21-75.25h171.6l28.21 75.25C294.9 472.1 307 480 320 480c3.734 0 7.531-.6562 11.23-2.031C347.8 471.8 356.2 453.3 349.1 436.8zM114.2 320L176 155.1l61.82 164.9H114.2z"
    })
  ])
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "stack_div_text" }
const _hoisted_6 = { class: "stack_div_text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fad",
  "data-icon": "image",
  class: "svg-inline--fa fa-image",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, [
  /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M928.768 595.328h-333.44v333.44h333.44z",
      fill: "#c9c1ec",
      "p-id": "32559"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M564.096 595.328c0-17.28 14.016-31.232 31.232-31.232h333.44c17.28 0 31.232 14.016 31.232 31.232v333.44c0 17.28-14.016 31.232-31.232 31.232h-333.44a31.296 31.296 0 0 1-31.232-31.232v-333.44z m62.528 31.296v270.848h270.848V626.624H626.624z",
      fill: "#c9c1ec",
      "p-id": "32560"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M282.816 95.232l187.52 333.44h-375.04z",
      fill: "#c9c1ec",
      "p-id": "32561"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M282.816 64c11.264 0 21.696 6.08 27.2 15.936l187.52 333.376a31.36 31.36 0 0 1-27.2 46.592h-375.04a31.232 31.232 0 0 1-27.328-46.592l187.52-333.44A31.296 31.296 0 0 1 282.88 64zM148.672 397.44h268.224L282.816 158.976 148.672 397.376z",
      fill: "#c9c1ec",
      "p-id": "32562"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M762.048 428.672a166.72 166.72 0 1 0 0-333.44 166.72 166.72 0 0 0 0 333.44z",
      fill: "currentColor",
      "p-id": "32563"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M564.096 261.952a197.952 197.952 0 1 1 395.968 0 197.952 197.952 0 0 1-395.968 0z m197.952-135.424a135.424 135.424 0 1 0 0 270.848 135.424 135.424 0 0 0 0-270.848zM73.152 573.248c12.224-12.16 32-12.16 44.16 0l333.44 333.44a31.232 31.232 0 1 1-44.16 44.16l-333.44-333.44a31.232 31.232 0 0 1 0-44.16z",
      fill: "currentColor",
      "p-id": "32564"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M450.752 573.248c12.16 12.224 12.16 32 0 44.16l-333.44 333.44a31.232 31.232 0 1 1-44.16-44.16l333.44-333.44c12.16-12.16 31.936-12.16 44.16 0z",
      fill: "currentColor",
      "p-id": "32565"
    })
  ])
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fad",
  "data-icon": "bars-staggered",
  class: "svg-inline--fa fa-bars-staggered",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-secondary",
      fill: "currentColor",
      d: "M64 256C64 238.3 78.33 224 96 224H480C497.7 224 512 238.3 512 256C512 273.7 497.7 288 480 288H96C78.33 288 64 273.7 64 256z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-primary",
      fill: "#c9c1ec",
      d: "M416 128H32C14.33 128 0 113.7 0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fad",
  "data-icon": "table-layout",
  class: "svg-inline--fa fa-table-layout",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-secondary",
      fill: "#c9c1ec",
      d: "M448 160V224H192V416H128V224H64V160H448z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-primary",
      fill: "currentColor",
      d: "M448 32C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H448zM448 96H64V416H448V96z"
    })
  ])
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fad",
  "data-icon": "browser",
  class: "svg-inline--fa fa-browser",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-secondary",
      fill: "#c9c1ec",
      d: "M128 128C128 145.7 113.7 160 96 160C78.33 160 64 145.7 64 128C64 110.3 78.33 96 96 96C113.7 96 128 110.3 128 128zM64 480C28.65 480 0 451.3 0 416V224H512V416C512 451.3 483.3 480 448 480H64z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-primary",
      fill: "currentColor",
      d: "M0 96C0 60.65 28.65 32 64 32H448C483.3 32 512 60.65 512 96V224H0V96zM96 160C113.7 160 128 145.7 128 128C128 110.3 113.7 96 96 96C78.33 96 64 110.3 64 128C64 145.7 78.33 160 96 160zM184 104C170.7 104 160 114.7 160 128C160 141.3 170.7 152 184 152H424C437.3 152 448 141.3 448 128C448 114.7 437.3 104 424 104H184z"
    })
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fad",
  "data-icon": "film",
  class: "svg-inline--fa fa-film",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-secondary",
      fill: "#c9c1ec",
      d: "M335.1 288H175.1c-8.836 0-16 7.164-16 16v96c0 8.836 7.164 16 16 16h160c8.836 0 16-7.164 16-16v-96C351.1 295.2 344.8 288 335.1 288zM335.1 96H175.1c-8.836 0-16 7.164-16 16v96c0 8.836 7.164 16 16 16h160c8.836 0 16-7.164 16-16v-96C351.1 103.2 344.8 96 335.1 96z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-primary",
      fill: "currentColor",
      d: "M463.1 32h-416C21.49 32-.0001 53.49-.0001 80v352c0 26.51 21.49 48 47.1 48h416c26.51 0 48-21.49 48-48v-352C511.1 53.49 490.5 32 463.1 32zM111.1 408c0 4.418-3.582 8-8 8H55.1c-4.418 0-8-3.582-8-8v-48c0-4.418 3.582-8 8-8h47.1c4.418 0 8 3.582 8 8L111.1 408zM111.1 280c0 4.418-3.582 8-8 8H55.1c-4.418 0-8-3.582-8-8v-48c0-4.418 3.582-8 8-8h47.1c4.418 0 8 3.582 8 8V280zM111.1 152c0 4.418-3.582 8-8 8H55.1c-4.418 0-8-3.582-8-8v-48c0-4.418 3.582-8 8-8h47.1c4.418 0 8 3.582 8 8L111.1 152zM351.1 400c0 8.836-7.164 16-16 16H175.1c-8.836 0-16-7.164-16-16v-96c0-8.836 7.164-16 16-16h160c8.836 0 16 7.164 16 16V400zM351.1 208c0 8.836-7.164 16-16 16H175.1c-8.836 0-16-7.164-16-16v-96c0-8.836 7.164-16 16-16h160c8.836 0 16 7.164 16 16V208zM463.1 408c0 4.418-3.582 8-8 8h-47.1c-4.418 0-7.1-3.582-7.1-8l0-48c0-4.418 3.582-8 8-8h47.1c4.418 0 8 3.582 8 8V408zM463.1 280c0 4.418-3.582 8-8 8h-47.1c-4.418 0-8-3.582-8-8v-48c0-4.418 3.582-8 8-8h47.1c4.418 0 8 3.582 8 8V280zM463.1 152c0 4.418-3.582 8-8 8h-47.1c-4.418 0-8-3.582-8-8l0-48c0-4.418 3.582-8 7.1-8h47.1c4.418 0 8 3.582 8 8V152z"
    })
  ])
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fad",
    "data-icon": "pen-field",
    class: "svg-inline--fa fa-pen-field",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512"
  }, [
    /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
      /*#__PURE__*/_createElementVNode("path", {
        class: "fa-secondary",
        fill: "#c9c1ec",
        d: "M0 208C0 163.8 35.82 128 80 128H272C289.7 128 304 142.3 304 160C304 177.7 289.7 192 272 192H80C71.16 192 64 199.2 64 208V432C64 440.8 71.16 448 80 448H496C504.8 448 512 440.8 512 432V304C512 286.3 526.3 272 544 272C561.7 272 576 286.3 576 304V432C576 476.2 540.2 512 496 512H80C35.82 512 0 476.2 0 432V208z"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        class: "fa-primary",
        fill: "currentColor",
        d: "M534.1 16.02C552.8-2.736 583.2-2.742 601.9 16.01L623.8 37.88C642.7 56.77 642.5 87.43 623.5 106.1L583.7 145.1L494.4 55.74L534.1 16.02zM560.8 167.5L415.6 309.6C408.7 316.4 400.3 321.5 391.1 324.6L319.6 348.5C310.1 351.4 301.5 349.1 295 342.7C288.6 336.3 286.4 326.8 289.2 318.1L313 246.8C316.1 237.4 321.4 228.8 328.5 221.8L471.7 78.37L560.8 167.5zM160 320C160 337.7 145.7 352 128 352C110.3 352 96 337.7 96 320C96 302.3 110.3 288 128 288C145.7 288 160 302.3 160 320zM192 320C192 302.3 206.3 288 224 288C241.7 288 256 302.3 256 320C256 337.7 241.7 352 224 352C206.3 352 192 337.7 192 320z"
      })
    ])
  ])
], -1))
const _hoisted_18 = { class: "handler-item group-btn" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fad",
  "data-icon": "image",
  class: "svg-inline--fa fa-image",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("g", { class: "fa-duotone-group" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-secondary",
      fill: "#c9c1ec",
      d: "M464 32h-416C21.49 32 0 53.49 0 80v352C0 458.5 21.49 480 48 480h416c26.51 0 48-21.49 48-48v-352C512 53.49 490.5 32 464 32zM111.1 96c26.51 0 48 21.49 48 48S138.5 192 111.1 192s-48-21.49-48-48S85.48 96 111.1 96zM446.1 407.6C443.3 412.8 437.9 416 432 416H82.01c-6.021 0-11.53-3.379-14.26-8.75c-2.73-5.367-2.215-11.81 1.334-16.68l70-96C142.1 290.4 146.9 288 152 288s9.916 2.441 12.93 6.574l32.46 44.51l93.3-139.1C293.7 194.7 298.7 192 304 192s10.35 2.672 13.31 7.125l128 192C448.6 396 448.9 402.3 446.1 407.6z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "fa-primary",
      fill: "currentColor",
      d: "M446.1 407.6C443.3 412.8 437.9 416 432 416H82.01c-6.021 0-11.53-3.379-14.26-8.75c-2.73-5.367-2.215-11.81 1.334-16.68l70-96C142.1 290.4 146.9 288 152 288s9.916 2.441 12.93 6.574l32.46 44.51l93.3-139.1C293.7 194.7 298.7 192 304 192s10.35 2.672 13.31 7.125l128 192C448.6 396 448.9 402.3 446.1 407.6z"
    })
  ])
], -1))
const _hoisted_20 = [
  _hoisted_19
]

import { ref, watch, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSnapshotStore } from '@/store'
import { getImageDataURL } from '@/utils/image'
import { ShapePoolItem } from '@/configs/shapes'
import { LinePoolItem } from '@/configs/lines'
import useScaleCanvas from '@/hooks/useScaleCanvas'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useCreateElement from '@/hooks/useCreateElement'
import { uploadFile } from '@/api/combo'
import { getPptIdByUrl } from "@/utils/common";
import AddElementModal from './AddElementModal.vue'
import ShapeStack from './ShapeStack.vue'
import LineStack from './LineStack.vue'
import ChartStack from './ChartStack.vue'

import ShapePool from './ShapePool.vue'
import LinePool from './LinePool.vue'
import ChartPool from './ChartPool.vue'
import TableGenerator from './TableGenerator.vue'
import MediaInput from './MediaInput.vue'
import LaTeXEditor from '@/components/LaTeXEditor/index.vue'
import FileInput from '@/components/FileInput.vue'
import LogoInput from './LogoInput.vue'
import {
  Tooltip,
  Popover,
  Modal,
} from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
import {
  uploadFileToOSS,
  getFileExtension
} from "@/utils/uploadOss";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  rightToolShow: {
    type: Boolean,
    default: true
  }
},
  emits: ['changeToolShow'],
  setup(__props, { emit }) {

const props = __props;

const { t, locale } = useI18n()
const mainStore = useMainStore()
const { creatingElement, handleElement, activeElementIdList, isAiGenerating, isPc, pptId } = storeToRefs(mainStore)
const { canUndo, canRedo } = storeToRefs(useSnapshotStore())
const { redo, undo } = useHistorySnapshot()

const {
  scaleCanvas,
  setCanvasScalePercentage,
  resetCanvas,
  canvasScalePercentage,
} = useScaleCanvas()

const canvasScalePresetList = [200, 150, 100, 80, 50]
const canvasScaleVisible = ref(false)

const applyCanvasPresetScale = (value: number) => {
  setCanvasScalePercentage(value)
  canvasScaleVisible.value = false
}

const {
  createImageElement,
  createChartElement,
  createTableElement,
  createLatexElement,
  createVideoElement,
  createAudioElement,
} = useCreateElement()

const insertImageElement = async (files: FileList) => {
  const imageFile = files[0]
  if (!imageFile) return
  let fileType = getFileExtension(imageFile.name);
  const fileRes: any = await uploadFileToOSS('content', imageFile, 2, fileType)
  const dataURL = fileRes.name
  createImageElement(dataURL)
}
const shapePoolVisible = ref(false)
const linePoolVisible = ref(false)
const chartPoolVisible = ref(false)
const tableGeneratorVisible = ref(false)
const mediaInputVisible = ref(false)
const latexEditorVisible = ref(false)
const textTypeSelectVisible = ref(false)
const logoSelectVisible = ref(false)






watch(() => [activeElementIdList, props.rightToolShow], () => {
  if (activeElementIdList.value.length !== 0 || !props.rightToolShow) {
    textTypeSelectVisible.value = false
    shapePoolVisible.value = false
    linePoolVisible.value = false
    chartPoolVisible.value = false
    tableGeneratorVisible.value = false
    mediaInputVisible.value = false
    logoSelectVisible.value = false
  }
})

watch(() => [textTypeSelectVisible.value, shapePoolVisible.value, linePoolVisible.value, chartPoolVisible.value, tableGeneratorVisible.value, mediaInputVisible.value, logoSelectVisible.value], (newVal, oldVal) => {
  let flag = newVal.some((ele) => { return ele })
  // if (flag) {
  emit('changeToolShow', flag)
  // }
})

// 绘制文字范围
const drawText = (vertical = false) => {
  mainStore.setCreatingElement({
    type: 'text',
    vertical,
  })
}

// 绘制形状范围
const drawShape = (shape: ShapePoolItem) => {
  mainStore.setCreatingElement({
    type: 'shape',
    data: shape,
  })
  shapePoolVisible.value = false
}

// 绘制线条路径
const drawLine = (line: LinePoolItem) => {
  mainStore.setCreatingElement({
    type: 'line',
    data: line,
  })
  linePoolVisible.value = false
}

const reSet = (type: number) => {
  mainStore.setActiveElementIdList([])
  if (type !== 1) textTypeSelectVisible.value = false
  if (type !== 3) shapePoolVisible.value = false
  if (type !== 4) linePoolVisible.value = false
  if (type !== 5) chartPoolVisible.value = false
  if (type !== 6) tableGeneratorVisible.value = false
  if (type !== 7) mediaInputVisible.value = false
  if (type !== 8) logoSelectVisible.value = false
  latexEditorVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_IconTextRotationNone = _resolveComponent("IconTextRotationNone")!
  const _component_IconTextRotationDown = _resolveComponent("IconTextRotationDown")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.2,
        title: _unref(t)(`editor.canvasTool.index.text`),
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "handler-item group-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {reSet(1); textTypeSelectVisible.value = !textTypeSelectVisible.value})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon", { 'active': (_unref(creatingElement)?.type === 'text' || _unref(handleElement)?.type === 'text') && !_unref(isAiGenerating) }])
            }, _hoisted_4, 2),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (textTypeSelectVisible.value)
                  ? (_openBlock(), _createBlock(AddElementModal, {
                      key: 0,
                      top: 200
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_unref(t)(`editor.canvasTool.index.text`)), 1),
                        _createElementVNode("div", {
                          class: "stack_div",
                          onClick: _cache[0] || (_cache[0] = () => { drawText(); textTypeSelectVisible.value = false })
                        }, [
                          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(`editor.canvasTool.index.horizontal`)), 1),
                          _createVNode(_component_IconTextRotationNone, { class: "color-icon" })
                        ]),
                        _createElementVNode("div", {
                          class: "stack_div",
                          onClick: _cache[1] || (_cache[1] = () => { drawText(true); textTypeSelectVisible.value = false })
                        }, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`editor.canvasTool.index.vertical`)), 1),
                          _createVNode(_component_IconTextRotationDown, { class: "color-icon" })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay", "title"]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.2,
        title: _unref(t)(`editor.canvasTool.index.shape`),
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "handler-item group-btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => {reSet(3); shapePoolVisible.value = !shapePoolVisible.value})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon", { 'active': (_unref(creatingElement)?.type === 'shape' || _unref(handleElement)?.type === 'shape') && !_unref(isAiGenerating) }])
            }, _hoisted_8, 2)
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (shapePoolVisible.value)
                ? (_openBlock(), _createBlock(AddElementModal, {
                    key: 0,
                    top: 150
                  }, {
                    content: _withCtx(() => [
                      _createVNode(ShapeStack, {
                        onSelect: _cache[4] || (_cache[4] = shape => drawShape(shape))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["mouseEnterDelay", "title"]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.2,
        title: _unref(t)(`editor.canvasTool.index.line`),
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "handler-item group-btn",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {reSet(4); linePoolVisible.value = !linePoolVisible.value})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon", { 'active': (_unref(creatingElement)?.type === 'line' || _unref(handleElement)?.type === 'line') && !_unref(isAiGenerating) }])
            }, _hoisted_10, 2)
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (linePoolVisible.value)
                ? (_openBlock(), _createBlock(AddElementModal, {
                    key: 0,
                    top: 200
                  }, {
                    content: _withCtx(() => [
                      _createVNode(LineStack, {
                        onSelect: _cache[6] || (_cache[6] = line => drawLine(line))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["mouseEnterDelay", "title"]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.2,
        title: _unref(t)(`editor.canvasTool.index.chart`),
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "handler-item group-btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => {reSet(5); chartPoolVisible.value = !chartPoolVisible.value})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon", { 'active': _unref(handleElement)?.type === 'chart' && !_unref(isAiGenerating) }])
            }, _hoisted_12, 2)
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (chartPoolVisible.value)
                ? (_openBlock(), _createBlock(AddElementModal, {
                    key: 0,
                    top: 250
                  }, {
                    content: _withCtx(() => [
                      _createVNode(ChartStack, {
                        onSelect: _cache[8] || (_cache[8] = chart => { _unref(createChartElement)(chart); chartPoolVisible.value = false })
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["mouseEnterDelay", "title"]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.2,
        title: _unref(t)(`editor.canvasTool.index.table`),
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "handler-item group-btn",
            onClick: _cache[11] || (_cache[11] = ($event: any) => {reSet(6); tableGeneratorVisible.value = !tableGeneratorVisible.value})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon", { 'active': _unref(handleElement)?.type === 'table' && !_unref(isAiGenerating) }])
            }, _hoisted_14, 2),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (tableGeneratorVisible.value)
                  ? (_openBlock(), _createBlock(AddElementModal, {
                      key: 0,
                      top: 150,
                      width: 260
                    }, {
                      content: _withCtx(() => [
                        _createVNode(TableGenerator, {
                          onClose: _cache[9] || (_cache[9] = ($event: any) => (tableGeneratorVisible.value = false)),
                          onInsert: _cache[10] || (_cache[10] = ({ row, col }) => { _unref(createTableElement)(row, col); tableGeneratorVisible.value = false })
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay", "title"]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.2,
        title: _unref(t)(`editor.canvasTool.index.voice`),
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "handler-item group-btn",
            onClick: _cache[15] || (_cache[15] = ($event: any) => {reSet(7); mediaInputVisible.value = !mediaInputVisible.value})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon", { 'active': (_unref(handleElement)?.type === 'video' || _unref(handleElement)?.type === 'audio') && !_unref(isAiGenerating) }])
            }, _hoisted_16, 2),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (mediaInputVisible.value)
                  ? (_openBlock(), _createBlock(AddElementModal, {
                      key: 0,
                      top: 300,
                      width: 320
                    }, {
                      content: _withCtx(() => [
                        _createVNode(MediaInput, {
                          onClose: _cache[12] || (_cache[12] = ($event: any) => (mediaInputVisible.value = false)),
                          onInsertVideo: _cache[13] || (_cache[13] = src => { _unref(createVideoElement)(src); mediaInputVisible.value = false }),
                          onInsertAudio: _cache[14] || (_cache[14] = src => { _unref(createAudioElement)(src); mediaInputVisible.value = false })
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay", "title"]),
      _createVNode(_unref(Tooltip), {
        color: "#5230f2",
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.2,
        title: _unref(t)(`editor.canvasTool.index.logo`),
        placement: "left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "handler-item group-btn",
            onClick: _cache[17] || (_cache[17] = ($event: any) => {reSet(8); logoSelectVisible.value = !logoSelectVisible.value})
          }, [
            _hoisted_17,
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (logoSelectVisible.value)
                  ? (_openBlock(), _createBlock(AddElementModal, {
                      key: 0,
                      style: {"box-shadow":"0px 0px 32px 7px rgba(0,0,0,0.1)","padding":"4px"}
                    }, {
                      content: _withCtx(() => [
                        _createVNode(LogoInput, {
                          onClose: _cache[16] || (_cache[16] = ($event: any) => (logoSelectVisible.value = !logoSelectVisible.value))
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay", "title"]),
      _createVNode(FileInput, {
        onChange: _cache[19] || (_cache[19] = files => insertImageElement(files))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Tooltip), {
            color: "#5230f2",
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.2,
            title: _unref(t)(`editor.canvasTool.index.image`),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(["icon", { 'active': _unref(handleElement)?.type === 'image' && !_unref(isAiGenerating) }]),
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (reSet(2)))
                }, _hoisted_20, 2)
              ])
            ]),
            _: 1
          }, 8, ["mouseEnterDelay", "title"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(Modal), {
      visible: latexEditorVisible.value,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((latexEditorVisible).value = $event)),
      footer: null,
      centered: "",
      width: 880,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(LaTeXEditor, {
          onClose: _cache[20] || (_cache[20] = ($event: any) => (latexEditorVisible.value = false)),
          onUpdate: _cache[21] || (_cache[21] = data => { _unref(createLatexElement)(data); latexEditorVisible.value = false })
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512)), [
    [_vShow, _unref(isPc)]
  ])
}
}

})